import type { PlanogramBay } from "@CommonTypes/merchflow/pog/bay";
import type { ThreePlanogram } from "../store/types";
import { Bay } from "./Bay/Bay";

interface Props {
  bays: PlanogramBay[];
  three: ThreePlanogram;
}

export const Bays = ({ bays, three }: Props) => {
  return bays.map((bay, index) => (
    <Bay key={bay.uniqueId} bay={bay} bayIndex={index} three={three} />
  ));
};
